import { Injectable } from '@angular/core';
import { LogService } from 'BaseServices/log-service';
import { LogDTO, LogType } from 'BaseDataTypes';
import { listRow } from '@standard-angular-utilities/shared-components';

@Injectable({
  providedIn: 'root',
})
export class LogHelperService {
  constructor(private logService: LogService) {}

  updateLogList(
    logType: LogType,
    nameResolver: (id: number) => string,
    setListData: (data: listRow<LogDTO>[]) => void,
    triggerUpdate: () => void = () => {}
  ) {
    this.logService.getLogsByType(logType).subscribe((logs) => {
      const rows: listRow<LogDTO>[] = logs.map((log) => ({
        object: log,
        id: log.id,
        data: [
          log.user.name,
          nameResolver(log.objectId),
          log.date,
          log.action,
          log.message,
        ],
      }));
      setListData(rows);
      triggerUpdate();
    });
  }
}
